import MainLayout from "@/components/layout/company/MainLayout.vue";
import { required, email, maxLength, minLength, numeric, sameAs } from "vuelidate/lib/validators";
import axios from "axios";
import $ from "jquery";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import store from "@/store";

export default {
    name: "companyRegister",

    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            social_id: this.data ? this.data.social_id : null,
            company_name: this.data ? this.data.name : '',
            email: this.data ? this.data.email : '',
            password: null,
            confirm_password: null,
            phone_number: "",
            company_logo: this.data ? this.data.company_logo : '',
            submitted: false,
            error_email: "",
            pass_error: false,
            pass_confirm_error: false
        };
    },

    props: ['data'],

    validations: {
        company_name: {
            required,
            maxLength: maxLength(100)
        },
        email: {
            required,
            email
        },
        password: {
            required,
            minLength: minLength(6)
        },
        confirm_password: {
            required,
            sameAsPassword: sameAs("password")
        },
        phone_number: {
            required,
            minLength: minLength(9),
            maxLength: maxLength(11),
            numeric
        },
    },

    methods: {
        onProfileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return null;

            if (files[0].size > 2097152) {
                this.$notification.error("ပုံအရွယ်အစားသည် 2MB ထက်မကျော်ရပါ။", {
                    timer: 3,
                    position: "bottomCenter"
                });
                e.target.value = "";
                return;
            }

            this.company_logo = e.target.files[0];
            let reader = new FileReader();
            reader.onload = e => {
                this.company_logo = e.target.result;
            };
            reader.readAsDataURL(files[0]);
        },

        submit() {
            this.submitted = true;
            if (!this.social_id) {
                if (this.password == null) {
                    this.pass_error = true;
                } else this.pass_error = false;
                if (this.confirm_password == null) {
                    this.pass_confirm_error = true;
                } else this.pass_confirm_error = false;
                if (this.pass_error || this.pass_confirm_error) {
                    return;
                }
            }
            if (this.$v.$invalid) {
                return;
            }
            this.companyRegister();
        },

        companyRegister() {
            $("#block-btn").attr("disabled", true);
            this.isLoading = true;
            const data = new FormData();
            if (this.company_logo) {
                if (this.company_logo.length < 10000000) {
                    data.append("company_logo", this.company_logo);
                } else {
                    data.append("company_logo", '');
                }
            } else {
                data.append("company_logo", '');
            }

            if (this.social_id == null) {
                data.append("social_id", '');
            } else data.append("social_id", this.social_id);

            data.append("company_name", this.company_name);
            data.append("email", this.email);
            data.append("password", this.password);
            data.append("phone_number", this.phone_number);
            data.append("company_logo", this.company_logo);
            
            axios.post("/company/register", data, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then(response=> {
                    $("#block-btn").attr("disabled", false);
                    console.log("API Success", response.data);
                    if (response.data.error_msg) {
                        this.image_size = response.data.msg;
                        this.isLoading = false;
                        this.$notification.error("သတ်မှတ်ထားသော ပုံအရွယ်အစားထက်ကြီးနေပါတယ်။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else if (response.data.msg) {
                        this.error_email = response.data.msg;
                        this.isLoading = false;
                        this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else if (response.data.data) {
                        if (response.data.data.token) {
                            store.commit("setCompanyData", response.data.data);
                            this.$router.push({
                                name: 'companyIndex'
                            });
                        }
                    }
                     else {
                        localStorage.setItem('companyEmail', this.email);
                        this.isLoading = false;
                        this.$router.push({
                            name: "companyLogin"
                        });
                    }
                })
                .catch(error => {
                    $("#block-btn").attr("disabled", false);
                    this.isLoading = false;
                    this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log("Company Register Error", error.errors);
                });
        }
    },
};
